import { AuthUserPermission } from '@cibo/core'
import { Can } from '@cibo/profile'
import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useProgramEngagementContext } from '../../../../context'
import { debugSx } from '@cibo/ui'
import { RequiredDocumentsAPI } from '../../../ResourceDetailFeatures/EQIP/RequiredDocumentsAPI'

export const PrefillEqipContractButton = () => {
  const { t } = useTranslation('@cibo/programs/PrefillEqipContractButton')
  const { engagementId } = useProgramEngagementContext()
  const [simulateOnly, setSimulateOnly] = useState(true)

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Button
          variant="contained"
          onClick={() => {
            engagementId && RequiredDocumentsAPI.inferContractData({ engagementId, simulateOnly })
          }}
        >
          {t('prefillValues')}
        </Button>
        <Can useAny={[AuthUserPermission.DEBUG_USER]}>
          <FormControlLabel
            sx={{ ...debugSx, pr: 1 }}
            control={
              <Checkbox checked={simulateOnly} onChange={e => setSimulateOnly(e.target.checked)} />
            }
            label={
              <Typography variant="caption" color="error">
                {t('simulateOnly')}
              </Typography>
            }
          />
        </Can>
      </Stack>
    </Box>
  )
}
